"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliceNonEmptyArray = exports.reverseNonEmptyArray = exports.isArrayNonEmpty = exports.addDataToDecoderError = exports.isErr = exports.isOk = exports.isString = exports.isNumber = exports.notEmpty = void 0;
const notEmpty = (value) => {
    return value !== null && value !== undefined;
};
exports.notEmpty = notEmpty;
const isNumber = (n) => Number.isFinite(n);
exports.isNumber = isNumber;
const isString = (value) => value !== null && value !== undefined && typeof value === "string";
exports.isString = isString;
const isOk = (result) => result.ok;
exports.isOk = isOk;
const isErr = (result) => result.err;
exports.isErr = isErr;
const addDataToDecoderError = (decodeError, data) => {
    return {
        name: decodeError.name,
        message: decodeError.message,
        stack: decodeError.stack,
        path: decodeError.path,
        data,
    };
};
exports.addDataToDecoderError = addDataToDecoderError;
const isArrayNonEmpty = (arr) => arr.length !== 0;
exports.isArrayNonEmpty = isArrayNonEmpty;
const reverseNonEmptyArray = (arr) => {
    return [...arr].reverse();
};
exports.reverseNonEmptyArray = reverseNonEmptyArray;
const sliceNonEmptyArray = (arr, params) => {
    return arr.slice(...Object.values(params));
};
exports.sliceNonEmptyArray = sliceNonEmptyArray;
//# sourceMappingURL=types.js.map